<div siqGrid 
  fx-direction="row" 
  fx-layout-align="space-between center" 
  class="menu-item background-transparent p-12 br-8" 
  [class.clicked-item]="item.clicked"
  [class.pointer-events-none]="isHealthDisabled"
  [class.cursor-pointer]="!isHealthDisabled"
  (click)="handleItemClick()">
  <div siqGrid fx-layout-align="space-between center" >
    <img class="menu-item-icon" [src]="iconPath" alt="icon"/>
    <div class="text-content" [class.primary-500]="isHealthDisabled" [class.white]="!isHealthDisabled && item.clicked" [class.primary-200]="!isHealthDisabled && !item.clicked">
      <span siqGrid="block" class="siq-text-700 fs-18 text-capitalize">{{itemTitle}}</span>
      <span class="siq-text-700 fs-18">{{itemSubtitle}}</span>
    </div>
  </div>
  @if(item.clicked) {
    <div class="arrow-right mr-4"></div>
  }
</div>
